import { FunctionComponent, useEffect, useState, ReactNode } from "react";
import Table from "../../../components/Table/Table";
import useIsMobile from "../../../hooks/useIsMobile";
import { CompletedBadge, InProgressBadge, NotStartedBadge } from "./exercise-badges";
import { useTranslation } from "react-i18next";
import { Exercise } from "src/graphql";

interface ExercisesTableProps {
    workoutExercises: Exercise[];
    onPressExercise?: (index: number) => any
}

const data = (workoutExercises: Exercise[], completed: number, inProgress?: number) => {
    return [
        ...workoutExercises.map((wex, i) => [
            wex.name,
            <div className='max-w-[100px] text-ellipsis overflow-hidden'>Strength</div>,
            "",
            "",
        ])]
}


const ExercisesTable: FunctionComponent<ExercisesTableProps> = ({ workoutExercises, onPressExercise }) => {

    const isMobile = useIsMobile();
    const [tableData, setTableData] = useState<ReactNode[][]>([])
    const [tableHeaders, setTableHeaders] = useState<string[]>([])
    const { t } = useTranslation();

    useEffect(() => {

        if (isMobile) {
            setTableHeaders([...[t("Exercise Name")]])
            setTableData([...data(workoutExercises, 0).map((d) => [...[d[0], d[4], d[5]]])])
        }
        else {
            setTableHeaders([...[t("Exercise Name"), t("section"), t("Machine Number"), t("Seat Height")]])
            setTableData([...data(workoutExercises, 0)])
        }

    }, [workoutExercises, isMobile])


    return (
        <section>
            <article>
                <h1 className='light-orange'>{t("Exercises")}</h1>
                <Table hidePagination
                    headers={tableHeaders}
                    data={tableData}
                    onClickItem={(idx) => onPressExercise && onPressExercise(idx)}
                />
            </article>
        </section>
    );
}

export default ExercisesTable;